import { render, staticRenderFns } from "./Block7.vue?vue&type=template&id=4c15e5ba&scoped=true"
import script from "./Block7.vue?vue&type=script&lang=js"
export * from "./Block7.vue?vue&type=script&lang=js"
import style0 from "./Block7.vue?vue&type=style&index=0&id=4c15e5ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15e5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c15e5ba')) {
      api.createRecord('4c15e5ba', component.options)
    } else {
      api.reload('4c15e5ba', component.options)
    }
    module.hot.accept("./Block7.vue?vue&type=template&id=4c15e5ba&scoped=true", function () {
      api.rerender('4c15e5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Block7.vue"
export default component.exports